import { SIGN_OUT, SIGN_IN_COMPLETE, SIGN_IN_ERROR, SIGN_IN_START, RESET_SIGN_IN_STATE, UPDATE_SIGNED_ACCOUNT_COMPLETE, UPDATE_SIGNED_ACCOUNT_ERROR, UPDATE_SIGNED_ACCOUNT_START } from './types'
import { AccountForFront } from '@mutual-services/pj-panel-types'
import { ServiceResponseError } from '~/utils/redux-rest-api/typeHelpers'

const INITIAL_STATE: InitialAuthState = {
  loading: false,
  error: null,
  account: null
}

type InitialAuthState = {
  loading: false,
  error: null,
  account: null
}

type SuccessAuthState = {
  loading: false,
  error: null,
  account: AccountForFront
}

type ErrorAuthState = {
  loading: false,
  error: ServiceResponseError,
  account: null
}

type LoadingAuthState = {
  loading: true,
  error: null,
  account: null
}

export type AuthState = LoadingAuthState | ErrorAuthState | SuccessAuthState | InitialAuthState

type Action = {
  payload: AccountForFront | null,
  type: string
}

export const authReducer = (prevState: AuthState = INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case SIGN_IN_START:
      return {
        ...INITIAL_STATE,
        loading: true
      }
    case UPDATE_SIGNED_ACCOUNT_START:
      return {
        ...prevState,
        loading: true
      }
    case SIGN_IN_COMPLETE:
      return {
        ...INITIAL_STATE,
        account: action.payload
      }
    case UPDATE_SIGNED_ACCOUNT_COMPLETE:
      return {
        ...prevState,
        account: action.payload
      }
    case SIGN_IN_ERROR:
      return {
        ...INITIAL_STATE,
        error: action.payload
      }
    case UPDATE_SIGNED_ACCOUNT_ERROR: {
      return {
        ...prevState,
        error: action.payload
      }
    }
    case SIGN_OUT:
      return INITIAL_STATE
    case RESET_SIGN_IN_STATE:
      return INITIAL_STATE
    default:
      return prevState
  }
}
